import React from 'react';

import _ from 'lodash';

import InvoicePaymentLineItemEntryTableRow from './InvoicePaymentLineItemEntryTableRow';

import './InvoicePaymentLineItemEntryTable.scss';

class InvoicePaymentLineItemEntryTable extends React.Component {
  _onEntryChange(ident) {
    return value => {
      this.props.onEntryChange(ident, value);
    };
  }

  render() {
    const {
      rows = [],
      fieldConfiguration,
      inputId,
      editMode
    } = this.props;

    return (
      <div className="parkchirp--invoice-payment-line-item-entry-table">
        <header className="parkchirp--invoice-payment-line-item-entry-table--header">
          <div className="parkchirp--selected-column parkchirp--invoice-payment-line-item-entry-table--cell"></div>
          <div className="parkchirp--invoice-line-item-title-column parkchirp--invoice-payment-line-item-entry-table--cell">
            <span className="parkchirp--invoice-payment-line-item-entry-table--column-heading">Description</span>
          </div>
          <div className="parkchirp--invoice-line-item-parker-name-column parkchirp--invoice-payment-line-item-entry-table--cell">
            <span className="parkchirp--invoice-payment-line-item-entry-table--column-heading">Parker</span>
          </div>
          <div className="parkchirp--invoice-line-item-balance-column parkchirp--invoice-payment-line-item-entry-table--cell">
            <span className="parkchirp--invoice-payment-line-item-entry-table--column-heading">Balance</span>
          </div>
          <div className="parkchirp--payment-entry-amount-column parkchirp--invoice-payment-line-item-entry-table--cell">
            <span className="parkchirp--invoice-payment-line-item-entry-table--column-heading">Amount</span>
          </div>
          <div className="parkchirp--payment-entry-amount-tax-1-column parkchirp--invoice-payment-line-item-entry-table--cell">
            <span className="parkchirp--invoice-payment-line-item-entry-table--column-heading">Tax 1</span>
          </div>
          <div className="parkchirp--payment-entry-amount-tax-2-column parkchirp--invoice-payment-line-item-entry-table--cell">
            <span className="parkchirp--invoice-payment-line-item-entry-table--column-heading">Tax 2</span>
          </div>
          <div className="parkchirp--payment-entry-amount-tax-3-column parkchirp--invoice-payment-line-item-entry-table--cell">
            <span className="parkchirp--invoice-payment-line-item-entry-table--column-heading">Tax 3</span>
          </div>
          <div className="parkchirp--payment-entry-amount-tax-4-column parkchirp--invoice-payment-line-item-entry-table--cell">
            <span className="parkchirp--invoice-payment-line-item-entry-table--column-heading">Tax 4</span>
          </div>
        </header>
        <div className="parkchirp--invoice-payment-line-item-entry-table--body">
          {rows.map((row, index) => {
            const { ident, invoiceLineItem, paymentEntry } = row;
            return (
              <InvoicePaymentLineItemEntryTableRow
                key={ident}
                lineItem={invoiceLineItem}
                entry={paymentEntry}
                fieldConfiguration={fieldConfiguration}
                onEntryChange={this._onEntryChange(ident)}
                inputId={`${inputId}--${index}`}
                editMode={editMode}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default InvoicePaymentLineItemEntryTable;
